import { render, staticRenderFns } from "./instory-list.vue?vue&type=template&id=33e8e2f1&scoped=true&"
import script from "./instory-list.vue?vue&type=script&lang=js&"
export * from "./instory-list.vue?vue&type=script&lang=js&"
import style0 from "./instory-list.vue?vue&type=style&index=0&id=33e8e2f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8e2f1",
  null
  
)

export default component.exports